import { PartnerSpotlightStatusesEnum } from '../../../../../constants';

export const PARTNER_SPOTLIGHT_STATUSES_LABELS = {
  [PartnerSpotlightStatusesEnum.GOLD]: '🥇 Gold',
  [PartnerSpotlightStatusesEnum.SILVER]: '🥈 Silver',
  [PartnerSpotlightStatusesEnum.BRONZE]: '🥉 Bronze',
};
